import React, { useEffect, useState } from 'react';
import { Wordmark } from '../../ui/index.js';
import { PrivacyNotice } from '../onboarding/PrivacyNotice.jsx';
import './privacy.css';

// /gizlilik (eksik taraması P0, 5 Kasım 2026): aydınlatma metninin kendi adresi. Tanıtım sitesindeki KVKK bağlantısı
// ve Google OAuth yayını için herkese açık bir gizlilik sayfası gerekiyor; metin onboarding'deki hesap sürümüyle aynı.
export function PrivacyPage() {
  const language = new URLSearchParams(location.search).get('lang') === 'en' ? 'en' : 'tr';
  const [config, setConfig] = useState(null);
  useEffect(() => { document.documentElement.lang = language; document.title = language === 'en' ? 'BiSponsor · Privacy notice' : 'BiSponsor · Aydınlatma metni'; fetch('/api/public/config').then(r => r.json()).then(setConfig).catch(() => setConfig({})); }, [language]);
  const en = language === 'en';
  return <main className="privacy-page">
    <a href="/" className="privacy-home" aria-label="BiSponsor"><Wordmark /></a>
    <h1>{en ? 'Privacy notice' : 'Kişisel verilerin korunması aydınlatma metni'}</h1>
    <p className="privacy-meta">{en ? 'Version' : 'Sürüm'} {config?.kvkkAccountVersion || '…'} · <a href={en ? '/gizlilik' : '/gizlilik?lang=en'}>{en ? 'Türkçe' : 'English'}</a></p>
    <PrivacyNotice language={language} controller={config?.controller} account />
    <p className="privacy-meta"><a href="/panel">{en ? 'Sign in' : 'Giriş yap'}</a> · <a href="/">{en ? 'Back to BiSponsor' : "BiSponsor'a dön"}</a></p>
  </main>;
}
